// equivalent to 1 hour
export const SPORTS_RECACHE_TIMEOUT = 3600000;

// Should not exceed SB's request timeout. (30 sec)
export const REQUEST_TIMEOUT = 10000;
export const SUPPORTED_LOCALES = ['en-gb', 'de-de', 'ja-jp', 'el-gr', 'ru-ru', 'es-es', 'it-it'];
export const DEFAULT_LOCALE = 'en-gb';

export const TOPICS = {
    MOBILE: 'breadcrumbsMobileClicked',
    DESKTOP: 'breadcrumbsDesktopClicked',
};
